import React from 'react';
import {BaseIconProps} from '../../types';

export const BaseLocationFilled: React.FC<BaseIconProps> = ({color, size}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.8889 10.3889C20.8889 12.2305 20.3272 13.9453 19.3658 15.3658C19.3253 15.4354 19.2789 15.5022 19.2267 15.5655C18.8808 16.0476 18.4881 16.4934 18.0551 16.8965L13.1255 22.4916C12.8407 22.8148 12.4308 23 12 23C11.5693 23 11.1593 22.8148 10.8745 22.4916L5.94522 16.8968C5.51192 16.4935 5.11892 16.0474 4.77291 15.565C4.721 15.502 4.67483 15.4356 4.63451 15.3664C3.67291 13.9457 3.11108 12.2308 3.11108 10.3889C3.11108 5.47969 7.09078 1.5 12 1.5C16.9092 1.5 20.8889 5.47969 20.8889 10.3889ZM14.3777 10.3889C14.3777 11.702 13.3132 12.7664 12.0001 12.7664C10.687 12.7664 9.62253 11.702 9.62253 10.3889C9.62253 9.0758 10.687 8.01133 12.0001 8.01133C13.3132 8.01133 14.3777 9.0758 14.3777 10.3889ZM18.0656 14.6096L18.0664 14.6084L18.0656 14.6096Z"
        fill={color}
      />
    </svg>
  );
};
